declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FacilityDetailInfoController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { FacilityDetailInfoRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { ConsumptionEntrypipe } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';



@Component({
  selector: 'printlayoutA4general',
  templateUrl: './printlayoutA4general.component.html',
  styleUrls: ['./printlayoutA4general.component.css']
})

export class  PrintlayoutA4generalComponent implements OnInit {

  //@Input() FormattedCode: string;
  public Date: Date;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public ClientHeaderFooterLine1: string = "";
  public ClientHeaderFooterLine2: string = "";
  public ClientHeaderFooterLine3: string = "";
  public ClientHeaderFooterLine4: string = "";

  public logo: string = "";
  public HeaderLine1: string = "";
  public HeaderLine2: string = "";
  public ClientHeaderSubTitle1: string = "";
  public ClientHeaderSubTitle2: string = "";

  //OPBillTitle: string = "Dot Matrix";
  //DotMatrixPrint: boolean = true;
  //LaserPrint: boolean = false;
  ShowGeneralPrintHeaderLogoCustomer: string = "true";
  ShowGeneralPrintHeaderLogo: string = "false";
  GeneralPrintHeaderHeight: number = 165;
  GeneralPrintHeaderEmpty: string = "false";
  ShowGeneralPrintFooter: string = "true";
  ShowGeneralPrintFooterEmpty: string = "false";
  GeneralFooterHeight: number = 150;
  DmFont: string = "normal normal 12px courier, arial";
  //BillPrintBodyWithPatientDetails: string = "false";
  
  public GST: string;
  public DL: string;
  public PatientId: any;
  public Branchname: string;
  public BillNumber: any;
  public PrintlogoWidth: number;
  public PrintlogoHeight: number;
  public PrintlogoBorderRadius: number;

 
  constructor(private router: Router,
    private loaderService: SpinnerService,    
    private actorservice: ActorService,    
    public printService: PrintService,
    private route: ActivatedRoute,
    //private parserFormatter: NgbDateParserFormatter,
  )
  {
    //this.myAngularxQrCode = 'this.FormattedCode';
  }


  ngOnInit() {
    this.PatientId = this.printService.GetCode();
    this.BillNumber = this.printService.GetBillNumber();
    this.ClientHeaderFooterLine1 = AppData.Instance().cas.ClientHeaderFooterLine1;
    this.ClientHeaderFooterLine2 = AppData.Instance().cas.ClientHeaderFooterLine2;
    this.ClientHeaderFooterLine3 = AppData.Instance().cas.ClientHeaderFooterLine3;
    this.ClientHeaderFooterLine4 = AppData.Instance().cas.ClientHeaderFooterLine4;
    this.Date = new Date();
    this.logo = AppData.Instance().cas.Hlogo;
    this.PrintlogoWidth = AppData.Instance().cas.PrintlogoWidth;
    this.PrintlogoHeight = AppData.Instance().cas.PrintlogoHeight;
    this.PrintlogoBorderRadius = AppData.Instance().cas.PrintlogoBorderRadius;
    this.HeaderLine1 = AppData.Instance().cas.ClientHeaderLine1;
    this.HeaderLine2 = AppData.Instance().cas.ClientHeaderLine2;
    this.ClientHeaderSubTitle1 = AppData.Instance().cas.ClientHeaderSubTitle1;
    this.ClientHeaderSubTitle2 = AppData.Instance().cas.ClientHeaderSubTitle2;

    //this.OPBillTitle = AppData.Instance().cas.OPBillTitle;
    //this.DotMatrixPrint = AppData.Instance().cas.DotMatrixPrint;
    //this.LaserPrint = AppData.Instance().cas.LaserPrint;
    this.ShowGeneralPrintHeaderLogoCustomer = AppData.Instance().cas.ShowGeneralPrintHeaderLogoCustomer;
    this.ShowGeneralPrintHeaderLogo = AppData.Instance().cas.ShowGeneralPrintHeaderLogo;
    this.GeneralPrintHeaderHeight = AppData.Instance().cas.GeneralPrintHeaderHeight;
    this.GeneralPrintHeaderEmpty = AppData.Instance().cas.GeneralPrintHeaderEmpty;
    this.ShowGeneralPrintFooter = AppData.Instance().cas.ShowGeneralPrintFooter;
    this.ShowGeneralPrintFooterEmpty = AppData.Instance().cas.ShowGeneralPrintFooterEmpty;
    this.GeneralFooterHeight = AppData.Instance().cas.GeneralFooterHeight;
    this.DmFont = AppData.Instance().cas.DmFont;
    //this.BillPrintBodyWithPatientDetails = AppData.Instance().cas.BillPrintBodyWithPatientDetails;

    this.LoadPatients();
    this.GST = AppData.Instance().GetDataParam('TinNo');
    this.DL = AppData.Instance().GetDataParam('DrugLicenceNo');
    //this.PatientId = this.route.snapshot.paramMap.get('documentName');
    //alert(this.PatientId);
    this.Branchname = AppData.Instance().SelectedBranchName;

  }
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.FormattedCode = this.route.snapshot.paramMap.get('FormattedCodedata');
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.PatientId;

    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadBills();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

 
 
 


 
}
